export default __webpack_public_path__ + "static/media/image5.5c4420fc.jpg";